export default __webpack_public_path__ + "images/logo-greentech.svg?b25faa2ae2a73906073740e1095b0ce6";